<h2>Customer</h2>
<p-table id="Customer" #dt [value]="details" styleClass="p-datatable-striped">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Type</th>
            <th>Customer Number</th>
            <th>Date of Birth</th>
            <th class="w--icon">Age</th>
            <th>Deceased Date</th>
            <th>SSN</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="6 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{ data.customerType }}</td>
            <td>{{ data.customerNumber }}</td>
            <td>{{ data.isBiometricRedacted ? '******' : data.dateOfBirth | shortDate }}</td>
            <td>{{ data.isBiometricRedacted ? '******' : data.age }}</td>
            <td>{{ data.deceasedDate | shortDate }}</td>
            <td>{{ data.ssn | ssn }}</td>
            <td class="text-center" *ngIf="canEdit">
                <a class="icon--edit" title="Edit Customer" href="javascript:void(0);"
                    (click)="editDetails(data.id)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>